// src/components/layouts/LogoutConfirmModal.tsx
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { LogOut } from 'lucide-react';
import './styles/LogoutConfirmModal.css';

interface LogoutConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onCancel();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const modalContent = (
    <div className="logout-modal-overlay" onClick={onCancel}>
      <div
        className="logout-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="logout-modal-icon">
          <div className="icon-circle">
            <LogOut size={32} />
          </div>
          <div className="icon-pulse"></div>
        </div>

        <h3 className="logout-modal-title">¿Cerrar sesión?</h3>
        <p className="logout-modal-message">
          ¿Estás seguro de que deseas cerrar sesión? Tendrás que iniciar sesión nuevamente para acceder.
        </p>

        <div className="logout-modal-actions">
          <button
            className="logout-btn-cancel"
            onClick={onCancel}
            type="button"
          >
            Cancelar
          </button>
          <button
            className="logout-btn-confirm"
            onClick={onConfirm}
            type="button"
          >
            <LogOut size={18} />
            <span>Cerrar sesión</span>
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default LogoutConfirmModal;

